import React from "react";
import Modal from "../../components/Modal";
import { Box, Dialog, DialogContent, DialogTitle, Grid, Icon, makeStyles } from "@material-ui/core";
import CustomTypo from "../../components/CustomTypo";
import { CloseIcon, DeleteIcon } from "../../components/icons";

const useStyles = makeStyles({
    paper: {
        background: `linear-gradient(#252525, #5a5a5a)`
    }
})
export default function DevicesView(props) {
    const { open, onClose, devices, onRemoveDevice } = props;
    const classes = useStyles();

    return (
        <>
            <Dialog open={open} onClose={onClose}
                fullWidth={true}
                classes={{ paper: classes.paper }}
            >
                <DialogTitle style={{ borderBottom: '1px solid #fff' }}>
                    <Grid item xs={12} container>
                        <Grid item xs={10}>
                            <CustomTypo variant="title" color={'onPrimary'}>Connected Devices</CustomTypo>
                        </Grid>
                        <Grid item xs={2} container onClick={onClose} justifyContent="flex-end" style={{ cursor: 'pointer' }}>
                            <CloseIcon/>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    {devices && devices.length > 0 ? <>
                        {devices.map((item, index) => {
                            let statusColor = '';
                            let status = '';
                            if (item.status == 0) {
                                status = 'Not Active';
                                statusColor = 'danger';
                            }
                            else if (item.status == 1) {
                                status = 'Active';
                                statusColor = 'success';
                            }
                            else if (item.status == 2) {
                                status = 'Banned';
                                statusColor = 'error'
                            }
                            let isLastItem = index == devices.length - 1;
                            return (
                                <Grid item xs={12} container alignItems="center" key={index} style={{
                                    marginBottom: 10,
                                    paddingBottom: 5,
                                    borderBottom: isLastItem ? undefined : '1px solid #ccc',
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                }}
                                >
                                    <Grid item xs={12} md={7}>
                                        <CustomTypo variant="subtitle1" color={'onPrimary'}>{item.name}</CustomTypo>
                                        <CustomTypo variant="body2" color={'onPrimary'}>{item.id}</CustomTypo>
                                        <CustomTypo variant="body2" color={'onPrimary'}>Last seen: {item.last_active == 0 ? 'Unknown' : formatDateTimeFrEpoch(item.last_active)}</CustomTypo>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <CustomTypo variant="subtitle1" style={{ textAlign: 'center' }} color={'onPrimary'}>Status</CustomTypo>
                                        <CustomTypo variant="h6" color={statusColor} style={{ textAlign: 'center' }}>{status}</CustomTypo>
                                    </Grid>
                                    <Grid item xs={12} md={2} container justifyContent="flex-end" style={{ cursor: 'pointer' }} onClick={() => onRemoveDevice(item)}>
                                        <DeleteIcon style={{ width: 24, height: 24 }} />
                                    </Grid>
                                </Grid>
                            )
                        })}
                    </> : <Box justifyContent={'center'} textAlign={'center'} minHeight={'50px'}>
                        <CustomTypo color={'onPrimary'}>No devices found</CustomTypo>
                    </Box>}
                </DialogContent>
            </Dialog>
        </>
    )
}

function formatDateTimeFrEpoch(date) {
    let utcDate = new Date(date);
    let convertDate = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Port_of_Spain",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    }).format(utcDate);
    console.log("AAAA formatDateTimeFrEpoch: ", convertDate)
    return convertDate;
}